// ABOUTME: Warehouse relation news management page.
// ABOUTME: Single-tab TabView3 hosting the relation news message list and editor.

import { Box, useTheme } from "@mui/material";
import TabView3 from "../../../../components/theme/TabView3/TabView3";
import { tokens } from "../../../../theme";
import { warehouseRelationNewsConfig } from "./warehouseRelationNewsConfig";
import All from "./views/All";

const WarehouseRelationNews = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box
            sx={{
                background: "",
                width: 1,
                paddingTop: 9,
            }}
        >
            <TabView3
                tabConfig={warehouseRelationNewsConfig}
                sx={{
                    minHeight: "calc(100%)",
                    background: `${
                        theme.palette.mode === "dark"
                        ? colors.grey[200]
                        : colors.grey[0]
                    }`,
                    position: "relative",
                    zIndex: 2,
                    display: "flex",
                    flexDirection: "column",
                    "&:before": {
                        content: "''",
                        display: "block",
                        width: "32px",
                        height: "48px",
                        position: "absolute",
                        left: 0,
                        top: "40px",
                        zIndex: 1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        borderTopLeftRadius: "24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transition: "250ms"
                    },
                    "&:after": {
                        content: "''",
                        display: "block",
                        width: "32px",
                        height: "48px",
                        position: "absolute",
                        top: "40px",
                        zIndex: 1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        right: 0,
                        borderTopLeftRadius: "24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transform: "scaleX(-1)",
                        transition: "250ms"
                    },
                    "@media screen and (max-width: 47.9375em)": {
                        "&:before, &:after": {
                            top: 0,
                            width: "24px",
                        }
                    }
                }}
            >
                <>
                    <All config={warehouseRelationNewsConfig.all} />
                </>
            </TabView3>
        </Box>
    )
};

export default WarehouseRelationNews;
